import React, { useState } from 'react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const InsertTableDialog = ({ open, onOpenChange, onInsert }) => {
  const [data, setData] = useState('');
  const [dataType, setDataType] = useState('csv');
  const [rows, setRows] = useState(3);
  const [cols, setCols] = useState(3);
  const [activeTab, setActiveTab] = useState('paste');

  const handleInsert = () => {
    if (activeTab === 'paste') {
      if (data.trim()) {
        onInsert({
          type: 'data',
          payload: { data, dataType },
        });
        setData('');
        onOpenChange(false);
      }
    } else if (activeTab === 'empty') {
      if (rows > 0 && cols > 0) {
        onInsert({
          type: 'empty',
          payload: { rows, cols },
        });
        setRows(3);
        setCols(3);
        onOpenChange(false);
      }
    }
  };

  const isInsertDisabled = () => {
    if (activeTab === 'paste') {
      return !data.trim();
    }
    if (activeTab === 'empty') {
      return !(rows > 0 && cols > 0);
    }
    return true;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] glass border-0">
        <DialogHeader>
          <DialogTitle>Insertar Tabla Inteligente</DialogTitle>
          <DialogDescription>
            Pega datos existentes o crea una tabla vacía con las dimensiones que necesites.
          </DialogDescription>
        </DialogHeader>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="paste">Pegar Datos</TabsTrigger>
            <TabsTrigger value="empty">Crear Tabla Vacía</TabsTrigger>
          </TabsList>
          <TabsContent value="paste">
            <div className="grid gap-4 py-4">
              <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="data-type" className="text-right">
                  Formato
                </Label>
                <Select value={dataType} onValueChange={setDataType}>
                  <SelectTrigger id="data-type" className="col-span-3">
                    <SelectValue placeholder="Selecciona el formato" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="csv">CSV</SelectItem>
                    <SelectItem value="md">Markdown</SelectItem>
                    <SelectItem value="json">JSON</SelectItem>
                    <SelectItem value="html">HTML</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="grid grid-cols-1 gap-2">
                <Label htmlFor="table-data">Datos de la Tabla</Label>
                <Textarea
                  id="table-data"
                  value={data}
                  onChange={(e) => setData(e.target.value)}
                  className="col-span-4 h-48"
                  placeholder="Ej: Nombre,Apellido,Edad..."
                />
              </div>
            </div>
          </TabsContent>
          <TabsContent value="empty">
            <div className="grid gap-4 py-4">
              <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="rows" className="text-right">
                  Filas
                </Label>
                <Input
                  id="rows"
                  type="number"
                  value={rows}
                  onChange={(e) => setRows(Math.max(1, parseInt(e.target.value, 10) || 1))}
                  className="col-span-3"
                />
              </div>
              <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="cols" className="text-right">
                  Columnas
                </Label>
                <Input
                  id="cols"
                  type="number"
                  value={cols}
                  onChange={(e) => setCols(Math.max(1, parseInt(e.target.value, 10) || 1))}
                  className="col-span-3"
                />
              </div>
            </div>
          </TabsContent>
        </Tabs>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleInsert} disabled={isInsertDisabled()}>
            Insertar Tabla
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InsertTableDialog;